import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from '../UsersInfo.module.less';

function DateCell({ cell: { value } }) {
  const date = value ? moment(value).format('DD MMM YYYY HH:mm') : 'Never used';

  return <div className={styles.date}>{date}</div>;
}

DateCell.propTypes = {
  cell: PropTypes.object,
};

export default DateCell;
